import {
    get,
    post,
    post2,
    put,
    put2,
    $delete
} from '@/plugins/axios.js'

export default {

    columns(params) {
        return post2('/api/report/columns', params)
    },
    scriptList(params) {
        return get('/api/report/script/list', params)
    },
    preview(reportId,elementId, params) {
        return post2(`/api/report/preview/${reportId}/${elementId}`, params)
    }


}
